import githubLanguagesData from "../../data/githubLanguages.json";

/** All language names accepted by GitHub search (`language:`), from github/linguist */
export const githubLanguages = githubLanguagesData;

export const defaultFilterState = {
  usernameExact: "",
  nameKeyword: "",
  followersMin: "",
  followersMax: "",
  followingMin: "",
  publicReposMin: "",
  language: "",
  topic: "",
  repoNameKeyword: "",
  lastActive: "",
  sortUsers: "",
  minStars: "",
  sortRepo: "stars",
  forksMin: "",
  maxStars: "",
};

/** @deprecated use githubLanguages */
export const popularLanguages = githubLanguagesData;
